import React from 'react';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.GREY_LIGHT_COLOR,
    borderRadius: theme.BUTTON_BORDER_RADIUS,
    marginTop: theme.CONTAINER_MARGIN,
    padding: theme.CONTAINER_MARGIN,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  image: {
    width: 40,
    height: 40,
    marginRight: theme.CONTAINER_MARGIN,
  },
  headline: {
    fontWeight: theme.FONT_WEIGHT_HEAVY,
    fontSize: theme.FONT_SIZE_HEADLINE,
    color: theme.GREY_DARKER_COLOR,
    fontFamily: 'Nunito_Bold',
  },
  amount: {
    paddingLeft: theme.CONTAINER_MARGIN,
    paddingRight: theme.CONTAINER_MARGIN,
    right: 0,
    position: 'absolute',
    fontSize: theme.FONT_SIZE_TITLE,
    color: theme.GREEN_WARM_COLOR,
    fontWeight: theme.FONT_WEIGHT_HEAVY,
    fontFamily: 'Nunito_Bold',
  },
});

export default function StatsContainer(props) {
  const { image, headline, subheader, amount, navigation, navigateTo } = props;

  if (navigateTo != null) {
    return (
      <TouchableOpacity
        testID="press"
        onPress={() => {
          navigation.navigate(navigateTo);
        }}
      >
        <View style={styles.container}>
          <Image style={styles.image} source={image} />
          <View style={styles.textContainer}>
            <CustomText style={styles.headline}>{headline}</CustomText>
            <CustomText style={styles.subheader}>{subheader}</CustomText>
          </View>
          <CustomText style={styles.amount}>{amount}</CustomText>
        </View>
      </TouchableOpacity>
    );
  }

  return (
    <View style={styles.container}>
      <Image style={styles.image} source={image} />
      <View style={styles.textContainer}>
        <CustomText style={styles.headline}>{headline}</CustomText>
        <CustomText style={styles.subheader}>{subheader}</CustomText>
      </View>
      <CustomText style={styles.amount}>{amount}</CustomText>
    </View>
  );
}
